import React from 'react';
import { getResponsiveAttributes } from '../internal/utils/getResponsiveAttributes.js';
import classes from './Stack.module.css.js';
import { clsx } from 'clsx';
import { toggleSxComponent } from '../internal/utils/toggleSxComponent.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const StackBaseComponent = toggleSxComponent('div');
function Stack({
  as,
  children,
  align = 'stretch',
  direction = 'vertical',
  gap,
  justify = 'start',
  padding = 'none',
  wrap = 'nowrap',
  className,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(StackBaseComponent, _extends({
    as: as
  }, rest, {
    className: clsx(className, classes.Stack)
  }, getResponsiveAttributes('gap', gap), getResponsiveAttributes('direction', direction), getResponsiveAttributes('align', align), getResponsiveAttributes('wrap', wrap), getResponsiveAttributes('justify', justify), getResponsiveAttributes('padding', padding)), children);
}
Stack.displayName = "Stack";
const StackItemBaseComponent = toggleSxComponent('div');
function StackItem({
  as,
  children,
  grow,
  className,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(StackItemBaseComponent, _extends({
    as: as
  }, rest, {
    className: clsx(className, classes.StackItem)
  }, getResponsiveAttributes('grow', grow)), children);
}
StackItem.displayName = "StackItem";

export { Stack, StackItem };
